{
  "titles": {
    "join": "Unirse a {{fboName}}",
    "invalidInvite": "Invitación no válida"
  },
  "messages": {
    "joinQuestion": "¿Quieres unirte a {{fboName}} en AirPlx?",
    "alreadyClaimed": "Ya reclamaste tu invitación. Ahora puedes acceder a tu cuenta en app.airplx.com. Te recomendamos guardar el enlace en tus favoritos para acceder rápidamente en el futuro."
  },
  "buttons": {
    "no": "No",
    "yes": "Sí",
    "ok": "Ok"
  }
}
